import {FC, useCallback, useEffect, useState} from "react";
import {ListItemText} from "../Menu.tsx";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import QRCode2Icon from "@mui/icons-material/QRCode2";
import apiClient from "../../lib/api.ts";
import Dialog from "@mui/material/Dialog";
import {SlideTransition} from "@memaro/components/Dialog.tsx";

export type QRCodeButtonProps = {
    profileID: string
    onClick?: () => void
}

const QRCodeButton: FC<QRCodeButtonProps> = ({profileID, onClick}) => {
    const [qrCodeURL, setQRCodeURL] = useState<string | undefined>()
    const [open, setOpen] = useState<boolean>(false)

    useEffect(() => {
        apiClient.getQRCodeURL(profileID).then(setQRCodeURL)
    }, [profileID])

    const handleClick = useCallback(() => {
        setOpen(true);
        onClick?.();
    }, [onClick])
    const handleClose = useCallback(() => setOpen(false), [])

    return qrCodeURL ? (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                slots={{
                    transition: SlideTransition,
                }}
                keepMounted
            >
                <img src={qrCodeURL} alt="QR-code"/>
            </Dialog>
            <ListItem disablePadding>
                <ListItemButton onClick={handleClick}>
                    <ListItemIcon>
                        <QRCode2Icon/>
                    </ListItemIcon>
                    <ListItemText primary="QR-code"/>
                </ListItemButton>
            </ListItem>
        </>
    ) : null
}

export default QRCodeButton
